// database/firebaseDb.js
import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app"



 
  
  
  
  var firebaseConfig={
	  apiKey: "AIzaSyB5xSTWf4nwrIG6coTFJeoGRVafDLeKR1E",
  authDomain: "zuribuiild.firebaseapp.com",
  projectId: "zuribuiild",
  storageBucket: "zuribuiild.firebasestorage.app",
  messagingSenderId: "465923017183",
  appId: "1:465923017183:web:3d227806882dcefbf7dc6a", 
  measurementId: "G-6P893K8Z6V"
  
	  
  }
  

 
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);




